import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-svg-card',
    templateUrl: './svg-card.html',
    styleUrls: ['./svg-card.css']
  })
  export class svgCard {
  
    @Input() color: string = "#333";
    @Input() icon: string = "https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg";
    @Input() name: string = "Produto Bankei";

    xmlData: string;
    svgSafe: SafeHtml;
    public color2: string;
  
    constructor(private sanitizer: DomSanitizer) { }

    ngOnInit() {
      this.icon = this.icon ? this.icon : "https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg" ;
      this.color = this.icon ? this.color : "#31373f" ;
      this.name = this.name ? this.name : "Produto Bankei" ;
      //this.color2 = this.shadeColor(this.color, -25);
    }
    
    shadeColor(color, percent: number) {
      let R = parseInt(color.substring(1,3),16);
      let G = parseInt(color.substring(3,5),16);
      let B = parseInt(color.substring(5,7),16);
  
      R = Math.round(R * (100 + percent) / 100);
      G = Math.round(G * (100 + percent) / 100);
      B = Math.round(B * (100 + percent) / 100);
  
      R = (R<255)?R:255;  
      G = (G<255)?G:255;  
      B = (B<255)?B:255;  
  
      var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
      var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
      var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));
  
      return "#"+RR+GG+BB;
  }

  }
  
  